import { ready } from '~/core'

const DISABLED_CLASS = 'disabled'

ready('table-swiper-arrows', '.table--chart', (table) => {
  const leftArrow = table.querySelector('.table__prev')
  const rightArrow = table.querySelector('.table__next')
  const scrollConfig = {
    behavior: 'smooth',
    block: 'nearest',
    inline: 'start',
  }

  if (!leftArrow && !rightArrow) return

  leftArrow.classList.add(DISABLED_CLASS)

  const headerColumns = table.querySelectorAll('thead tr th') || []
  const firstColumn = headerColumns[0]
  const lastColumn = headerColumns[headerColumns.length - 1]

  leftArrow.addEventListener('click', () => {
    rightArrow.classList.toggle(DISABLED_CLASS)
    leftArrow.classList.toggle(DISABLED_CLASS)
    firstColumn.scrollIntoView(scrollConfig)
  })

  rightArrow.addEventListener('click', () => {
    rightArrow.classList.toggle(DISABLED_CLASS)
    leftArrow.classList.toggle(DISABLED_CLASS)
    lastColumn.scrollIntoView(scrollConfig)
  })
})
